import { useQuery } from '@apollo/client';

import { PricingPlanDocument } from './graphql/pricingPlan.gql';

export const useCurrentPricingPlanQuery = (
  companyProfileId?: string | null,
) => {
  const { data, error, loading } = useQuery(PricingPlanDocument, {
    skip: !companyProfileId,
    variables: {
      companyProfileId: companyProfileId as string,
    },
  });

  if (loading || error || !data) {
    return { data: null, error, loading };
  }

  return {
    data: {
      currentPlan: data.viewer.company.currentPlan,
    },
    error,
    loading,
  };
};

export type CurrentPricingPlan = NonNullable<
  NonNullable<
    Awaited<ReturnType<typeof useCurrentPricingPlanQuery>>['data']
  >['currentPlan']
>;

/**
 * Value intended to be used to refetch the query when mutations impacting
 * the plan are executed.
 */
export const CurrentPricingPlanDocument = PricingPlanDocument;
